// extracted by mini-css-extract-plugin
export default {"formContainer":"SupportNewMessage_formContainer__BsXwj","formHolder":"SupportNewMessage_formHolder__H1LXZ"};